import { Component, OnInit, ViewChild } from '@angular/core';
import { Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";
import Helper from 'src/app/core/utility/helper';

@Component({
  selector: 'app-proposal-gap-confirm',
  templateUrl: './proposal-gap-confirm.component.html',
  styleUrls: ['./proposal-gap-confirm.component.scss']
})
export class ProposalGapConfirmComponent implements OnInit {
  
  constructor(
    private dialogRef: MatDialogRef<ProposalGapConfirmComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    ) {}

  ngOnInit() {
    
  }

  formatDate(date) {
    return Helper.formatDate(date.split('T')[0]);
  }

  close(action: string) {
    this.dialogRef.close(action);
  }
  
}
